const a = {
  code: "it",
  facebook: "it_IT",
  label: "Italiano",
  loadingText: "Caricamento in corso...",
  translations: {
    ar: "Araba",
    de: "Tedesco",
    en: "English",
    es: "Spagnolo",
    fr: "French",
    he: "Ebraico",
    hi: "Hindi",
    id: "Indonesiana",
    it: "Italiano",
    ja: "Japanese",
    km: "Khmer",
    ko: "Korean",
    lo: "Lao",
    ms: "Malese",
    nl: "Olandese",
    pt: "Portoghese",
    ru: "Russo",
    th: "Tailandese",
    tl: "Filippina",
    tr: "Turca",
    vi: "Vietnamita",
    "zh-CN": "Chinese (simp.)",
    "zh-TW": "Chinese (trad.)"
  }
};
export {
  a as italian
};
